export const CATEGORY_LABELS = {
    chaines: "Chaînes",
    boucles: "Boucles d'oreille",
    pendentifs: "Pendentifs",
    bracelets: "Bracelets",
};

export const CATEGORY_SINGULAR = {
    chaines: "Chaîne",
    boucles: "Boucles d'oreille",
    pendentifs: "Pendentif",
    bracelets: "Bracelet",
};

export const SIZE_LABEL = {
    chaines: "Longueur",
    boucles: "Taille",
    pendentifs: "Longueur chaîne",
    bracelets: "Tour de poignet",
};
